export default __webpack_public_path__ + "static/media/10-2.cd38cc44.jpg";